import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable  } from 'rxjs';
import { map } from 'rxjs/operators'
import { EnvService } from '../../core/env.service';
import {ServiceLevelDTO} from '../../model/ServiceLevelDTO';
import {GeoCountryDTO} from '../../model/GeoCountryDTO';
import { LocationDTO } from 'src/app/model/LocationDTO';
import { UOMDTO } from 'src/app/model/UOMDTO';
import { CarrierDTO } from 'src/app/model/CarrierDTO';
import {RateTemplateDTO} from 'src/app/model/RateTemplateDTO';
import {MultiRateRequestDTO} from 'src/app/model/MultiRateRequestDTO';
import { ShipmentModeDTO } from 'src/app/model/ShipmentModeDTO';
import { MultiRaterTemplateDTO } from 'src/app/model/MultiRaterDTO';
import { GlobalService } from '../../commonservices/global.service';

const headers = new HttpHeaders().set('Content-Type','application/json')

@Injectable()
export class MultiRaterService {
    progress: number =0;
    constructor(
        private _httpClient: HttpClient, 
        public _env: EnvService,
        private globalS: GlobalService) {
    }

    GetAccessorials(client: string): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + `Populate/accessorials/${client}`, { 
            headers: headers 
        }).pipe(map((res: any[]) => res));
    }

    GetPostCodes(data: any): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + `Populate/postcodes`, { 
            params: this.globalS.serialize(data), 
            headers: headers 
        }).pipe(map((res: any[]) => res));
    }

    GetState(data: any): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + `Populate/state`, { 
            params: this.globalS.serialize(data), 
            headers: headers 
        }).pipe(map((res: any[]) => res));
    }

    GetDimensionUnits(): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + `Populate/GetDimensionUnits`, { headers: headers }).pipe(map((res: any[]) =>res));
    }

    GetUOMByClient(client: string): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + `Populate/GetUOMByClient/${client}`, { headers: headers })
        .pipe(map((res: any[]) =>res));
    }

    GetShipmentModeByClient(client: string): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + `Populate/GetShipmentModeByClient/${client}`, { headers: headers })
        .pipe(map((res: any[]) =>res));
    }

    GetCarrierByClient(client: string): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + `Populate/GetCarrierByClient/${client}`, { headers: headers })
        .pipe(map((res: any[]) =>res));
    }

    GetServiceLevelByClient(client: string): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + `Populate/GetServiceLevelByClient/${client}`, { headers: headers })
        .pipe(map((res: any[]) =>res));
    }

    getAllClients(): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + 'template/GetClient', { headers: headers })
        .pipe(map((res: any[]) =>res));
    }

    // getAccessorials():Observable<any>{
    //     return this._httpClient.get<any[]>(this._env.apictgf + 'MultiRater/GetAccessorials')
    //                 .pipe(map((res: any[]) =>res));
    // }

    getFreightTermsList():Observable<any>{
        return this._httpClient.get<any[]>(this._env.apictgf + 'MultiRater/GetFreightTerms')
                    .pipe(map((res: any[]) =>res));
    }

    // postMultiRate(template: MultiRateRequestDTO): Observable<any>{
    //     const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json'}) };
    //     return this._httpClient.post<MultiRateRequestDTO>(this._env.apiRateEngine +'rateengine/multirate', template, { headers: headers })
    //     .pipe(map((res: any) => res));
    // }

    postMultiRate(template: MultiRateRequestDTO,pageNo:number,pageSize:number): Observable<any>{
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json'}) };
        return this._httpClient.post<MultiRateRequestDTO>(this._env.apiRateEngine +'rateengine/multirate?pageNo='+pageNo +'&pageSize='+pageSize, template, { headers: headers })
        .pipe(map((res: any) => res));
    }
    getUOMs(): Observable<Array<UOMDTO>>{
        return this._httpClient.get<Array<UOMDTO>>(this._env.apiRateEngine + 'Populate/GetUOMs')
        .pipe(map((res: Array<UOMDTO>) =>res));
    }


    getTemplates(): Observable<any>{
        return this._httpClient.get<any[]>(this._env.apiRateEngine + 'template/GetMultiRaterTemplates', { headers: headers })
                    .pipe(map((res: any[]) =>res));
    }

    getCarrierShortNameList():Observable<any>{
        return this._httpClient.get<any[]>(this._env.apictgf + 'MultiRater/GetCarrierShortNameList')
                    .pipe(map((res: any[]) =>res));
    }

    getShipmentModes(): Observable<any>{
        return this._httpClient.get<ShipmentModeDTO[]>(this._env.apictgf + 'multirater/getshipmentmode')
                    .pipe(map((res: ShipmentModeDTO[]) =>res));
    }

    deleteTemplate(templateId: any): Observable<any>{
        return this._httpClient.delete(this._env.apiRateEngine + 'template/DeleteMultiRaterTemplate', { 
            params: this.globalS.serialize(templateId) 
        }).pipe(map((res: any[]) => res))
    }

    postTemplate(data: MultiRaterTemplateDTO): Observable<any>{
        return this._httpClient.post<any[]>(this._env.apiRateEngine + 'template/PostMultiRaterTemplate', data)
                .pipe(map((res: any[]) =>res));
    }

    updateTemplate(data: MultiRaterTemplateDTO): Observable<any>{
        return this._httpClient.put<any[]>(this._env.apiRateEngine + 'template/PutMultiRaterTemplate', data)
                .pipe(map((res: any[]) =>res));
    }

    getCountriesList(): Observable<any>{
        return this._httpClient.get('https://restcountries.eu/rest/v2/all').pipe(map((res: Array<any>) =>res));
    }

    getRate():Observable<any>{
        return this._httpClient.post<MultiRateRequestDTO>(this._env.apiRateEngine +'rateengine/multirate', {
            "ClientCode": "FMNGBL",
            "OriginCountry": "DE",
            "OriginState": "",
            "OriginPostcode": "",
            "OriginCity": "",
            "DestinationCountry": "DE",
            "DestinationState": "",
            "DestinationPostcode": "",
            "DestinationCity": "",
            "ShipmentDate": new Date(),
            "Uoms": [
            
            ],
            "Accessorials": [
                
            ]
        }, { headers: headers })
        .pipe(map((res: any) => res));
    }

    getServiceLevel(): Observable<Array<ServiceLevelDTO>>{
        return this._httpClient.get<Array<ServiceLevelDTO>>(this._env.apictgf + 'MultiRater/GetServiceLevels')
                    .pipe(map((res: Array<ServiceLevelDTO>) =>res));
    }

    getCountries(): Observable<Array<GeoCountryDTO>>{
        return this._httpClient.get<Array<GeoCountryDTO>>(this._env.apictgf + 'MultiRater/GetCountries')
                    .pipe(map((res: Array<GeoCountryDTO>) =>res));
    }

    getPostCodes(): Observable<Array<LocationDTO>>{
        return this._httpClient.get<Array<LocationDTO>>(this._env.apictgf + 'MultiRater/GetPostCode')
        .pipe(map((res: Array<LocationDTO>) =>res));
    }

    getCarriers(): Observable<Array<CarrierDTO>>{
        return this._httpClient.get<Array<CarrierDTO>>(this._env.apictgf + 'MultiRater/GetCarriers')
        .pipe(map((res: Array<CarrierDTO>) => res));
    }

    getTemplatesByUserId(): Observable<Array<RateTemplateDTO>>{
        return this._httpClient.get<Array<RateTemplateDTO>>(this._env.apictgf + 'MultiRater/GetTemplatesByUserId')
        .pipe(map((res: Array<RateTemplateDTO>) => res));
    }

    saveTemplate(template: RateTemplateDTO): Observable<RateTemplateDTO> {
        //console.log(template);        
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json'}) };
        return this._httpClient.post<RateTemplateDTO>(this._env.apictgf +'MultiRater/InsertRateTemplate',template)
        .pipe(map((res: RateTemplateDTO) => res));
    }

    getTemplateById(id: number): Observable<RateTemplateDTO>{
        return this._httpClient.get<RateTemplateDTO>(this._env.apictgf + 'MultiRater/GetTemplateById?id='+id)
        .pipe(map((res: RateTemplateDTO) => res));
    }  

}